var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoMinimal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 37.5764C16.7625 37.4954 18.6765 37.3739 19.1625 37.1714C20.1345 36.8474 20.418 36.1994 20.418 35.3084V12.9524C20.418 12.0614 20.1345 11.2919 19.1625 10.9274C18.5145 10.7249 16.6815 10.5224 15.75 10.4819V10.1984H32.6775V10.4819C31.989 10.5224 29.9565 10.6844 29.268 10.8869C28.296 11.1704 28.053 11.9804 28.053 12.8714V35.1869C28.053 36.0779 28.3365 36.8069 29.268 37.1714C29.754 37.3334 31.7865 37.4954 32.6775 37.5764V37.8599H15.75V37.5764Z",
    fill: "#16191A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMinimal);
export default __webpack_public_path__ + "static/media/logo-minimal.78594455bd942b5a4810922c506f24be.svg";
export { ForwardRef as ReactComponent };